define.alias("shared/components/shared/social/basic-display-deprecation/wizard", "settings/components/shared/social/basic-display-deprecation/wizard");